import { InjectionToken } from "@angular/core";

export const AUTHENTICATION_CONFIG = new InjectionToken(
    'AUTHENTICATION_CONFIG'
  );